export class NoopScheme {
    enable() { }
    disable() { }
    sample() {
        return {
            moveForwardBack: 0,
            moveLeftRight: 0,
            moveUpDown: 0,
            deltaYaw: 0,
            deltaPitch: 0,
        };
    }
}
